/***
 * Created on 2024/6/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import page_not_found_svg from '../static/img/illustration/illustration-page-not-found.png';
import {useTranslation} from "react-i18next";

function PageNotFound(props) {
    const { t } = useTranslation();

    return (
        <section className="common-page-wrapper common-page-wrapper--page-not-found">
            <div className="common-page-body">
                <div className="page-not-found--infographic">
                    <div className="page-not-found--infographic__source">
                        <img src={page_not_found_svg} alt=""/>
                    </div>
                </div>
                <div className="page-not-found--info">
                    <p className="font-medium text-26 line-height-25 !mb-24">
                        {t("@We're sorry.@")}
                        <br />
                        {t('@The page you are looking for cannot be found.@')}
                    </p>
                    <p className="text-15 !mb-40">
                        {t('@Please revise your entered URL and try again.@')}
                    </p>
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-full !w-fit mt24" onClick={e=> location.href='/'}>
                        {t('@Home@')}
                    </button>
                </div>
            </div>
        </section>
    );
}

export default PageNotFound;